import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { ModalAllder } from "./ModalAllder";
import { Button, Form } from "react-bootstrap";
export default function ReceiptModalGroup(param) {
    var setFieldValue = param.setFieldValue, handleChange = param.handleChange, modalReceiptModalState = param.modalReceiptModalState, values = param.values;
    var modalConfirmCancel = modalReceiptModalState.modalConfirmCancel, setModalConfirmCancel = modalReceiptModalState.setModalConfirmCancel, modalSuccess = modalReceiptModalState.modalSuccess, setModalSuccess = modalReceiptModalState.setModalSuccess, modalSaveSuccess = modalReceiptModalState.modalSaveSuccess, setModalSaveSuccess = modalReceiptModalState.setModalSaveSuccess, modalNotApprove = modalReceiptModalState.modalNotApprove, setModalNotApprove = modalReceiptModalState.setModalNotApprove, modalAlert = modalReceiptModalState.modalAlert, setModalAlert = modalReceiptModalState.setModalAlert;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2 flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalNotApprove,
                setModal: setModalNotApprove,
                htitle: "ยืนยันการไม่อนุมัติ",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลไม่อนุมัติ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-2  tc-10",
                                    children: "การดำเนินการ"
                                }),
                                [
                                    "radio"
                                ].map(function(type) {
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "ยกเลิกเอกสาร",
                                            name: "dim_mst_receipt_status_id",
                                            onChange: function() {
                                                return setFieldValue("dim_mst_receipt_status_id", 5);
                                            },
                                            type: type,
                                            id: "receipt$1rs-".concat(type, "-20"),
                                            className: "form-check-st-2 tc-7"
                                        })
                                    }, "inline-".concat(type));
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-5 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalNotApprove(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalConfirmCancel,
                setModal: setModalConfirmCancel,
                htitle: "ยืนยันการยกเลิก",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการยกเลิก ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 5,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-4 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalConfirmCancel(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function(e) {
                                        // e.preventDefault();
                                        setFieldValue("dim_mst_receipt_status_id", 3);
                                    },
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
